import { lumber } from '@mc-alberta/lumber'
import state from '../../../state'
import events from '../../../../events.json'

const routines = {
  /**
   * Routine to be done before re-opening SRCi in a CHANGE_CARD situation
   */
  async onChangeCard () {
    await logRelaunchRoutineErrorOnFailure(
      async () => {
        await state.aggregator.src.isRecognized() // cannot throw

        // with new aggregated checkout flow, idTokens from checkout are now
        // available in the aggregator store and there is no need to use the
        // returned idToken anymore. Calling getSrcProfile without params will
        // cause the aggregator preprocessor to look for all tokens from
        // isRecognized, completeIdentityValidation, and checkout
        await state.aggregator.src.getSrcProfile()
      }
    )
  },

  /**
   * Routine to be done before re-opening SRCi in a SWITCH_CONSUMER situation
   * @param {boolean} unbindAppInstance
   */
  async onSwitchConsumer ({ unbindAppInstance }) {
    await logRelaunchRoutineErrorOnFailure(
      async () => {
        state.aggregator.store.resetState()
        const { recognized } = await state.aggregator.src.isRecognized() // cannot throw
        // If recognized equals true upon switch consumer, this means that unbindAppInstance
        // was unsuccessful for the given sdk.
        if (recognized) {
          // `unbindAppInstance` is a flag sent from DCF upon relaunching SRCi.
          // When unbindAppInstance is true, the intended behavior is to delete
          // all appInstance cookies and clear recognized profiles.
          if (unbindAppInstance) {
            // unbindError is an UI flag used to manage error modal state.
            // When set to true, it will show the error modal in SRCi
            state.unbindError = true
          }
          await state.aggregator.src.getSrcProfile()
        }
      }
    )
  },

  /**
   * Performs unbind on every sdks upon request from DCF (`remember me` unchecked, or `switch consumer`)
   * @param {object} dcfResponse
   */
  async handleUnbindRequest ({ unbindAppInstance, idToken }) {
    // If unbindAppInstance is true, DCF is requesting MJS to call unbindAppInstance
    if (unbindAppInstance) {
      // src.unbindAppInstance must be awaited to ensure the user is not
      // erroneously recognized following an unbind request received
      // from DCF.  SWITCH_CONSUMER dcfActionCode is an example of where
      // isRecognized will be invoked after the checkout method resolves.
      await state.aggregator.src.unbindAppInstance({ idToken }) // cannot throw
      // Also note that `state.unbindError` will only be computed later in the flow, when `isRecognized` is called, for better accuracy
    }
  }
}

/**
 * Logs a standard error when a routine used before relaunching SRCI fails (also silences the error as it is considered recoverable)
 * @param {function} routine
 */
async function logRelaunchRoutineErrorOnFailure (routine) {
  try {
    await routine()
  } catch (error) {
    lumber.error({
      ...events.errors.RELAUNCH_SRCI_ERROR,
      details: {
        message: `An error occured while attempting to reinitialize SRCi from DCF`
      }
    })
  }
}

export default routines
